import React, { useState, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import "react-datepicker/dist/react-datepicker.css";

interface SingleDatePickerProps {
    className?: string;
    onDateChange?: (date: Date) => void;
    inline?: boolean;
}

const SingleDatePicker: React.FC<SingleDatePickerProps> = ({ className = '', onDateChange, inline = false }) => {
    const [startDate, setStartDate] = useState<Date | null>(new Date());

    const handleDateChange = (date: Date | null) => {
        setStartDate(date);
        if (date && onDateChange) {
            onDateChange(date);
        }
    };



    // Custom Input Component
    const CustomInput = forwardRef<HTMLDivElement, any>(({ onClick }, ref) => (
        <div className={`input-group ${className}`} onClick={onClick} ref={ref}>
            <div className={`form-control bg-transparent`} style={{ cursor: 'pointer' }}>
                <span>
                    {startDate ? dayjs(startDate).format('MMM D, YYYY h:mm A') : 'Select Date & Time'}
                </span>
            </div>
            <span className="input-group-text text-theme-1 bg-transparent"><i className="bi bi-calendar-event"></i></span>
        </div>
    ));

    return (
        <div className={`position-relative w-100 ${inline ? 'react-datepicker-inline' : ''}`}>
            <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                customInput={inline ? undefined : <CustomInput />}
                inline={inline}
                dateFormat="MMM d, yyyy h:mm aa"
                popperPlacement="top-end"
                wrapperClassName="w-100"
            >
                {/* <div className="p-2">
                    <select
                        className="form-select form-select-sm"
                        value={startDate ? dayjs(startDate).format('HH:mm') : '00:00'}
                        onChange={handleTimeChange}
                    >
                        {times.map(t => (
                            <option key={t} value={t}>{t}</option>
                        ))}
                    </select>
                </div> */}
            </DatePicker>
        </div>
    );
};

export default SingleDatePicker;
